import { RelatorioIncon } from './../models/relatorio-incon';
import { TipoMovimentacao } from './../models/tipo-movimentacao';
import { catchError } from 'rxjs/operators';
import { Movimentacao } from './../models/movimentacao';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { Evidencia } from '../models/evidencia';
import { Relatorio } from '../models/relatorio';
@Injectable({
  providedIn: 'root'
})
export class MovimentacaoService {
  //CRUD MOVIMENTAÇÃO
  private readonly PATH_MOV = '/Movimentacao';
  private readonly PATH_MOV_GET_ALL = '/Movimentacao/GetAll';
  private readonly PATH_LIBERAR = '/Movimentacao/Liberar';
  private readonly PATH_APROVAR = '/Movimentacao/Aprovar';
  private readonly PATH_REPROVAR = '/Movimentacao/Reprovar';
  private readonly PATH_RECEBER = '/Movimentacao/Receber';
  private readonly PATH_NO_RECEBER = '/Movimentacao/NaoRecebido';
  private readonly PATH_GESTOR = '/Movimentacao/gestor';
  private readonly PATH_DESTINO = '/Movimentacao/destino';
  private readonly PATH_HIST = '/Movimentacao/historico';
  private readonly PATH_RELATORIO = '/Movimentacao/Relatorio/';
  private readonly PATH_MOV_GESTOR_GET_ALL = '/Movimentacao/gestor/GetAll';
  private readonly PATH_MOV_DESTINO_GET_ALL = '/Movimentacao/destino/GetAll';
  private readonly PATH_MOV_INCON_ORIG_ALL = '/Movimentacao/Inconsistencia/Origem/GetAll';
  private readonly PATH_MOV_INCON_GET_ALL = '/Movimentacao/Inconsistencia/GetAll';
  private readonly PATH_MOV_INCON_RELATORIO = '/Movimentacao/Inconsistencia/Relatorio';
  private readonly PATH_MOV_INCON_ORIG_CONF = '/Movimentacao/Inconsistencia/Origem/Confirmar';
  private readonly PATH_MOV_INCON_GESTOR_CONF = '/Movimentacao/Inconsistencia/Gestor/Confirmar';
  private readonly PATH_MOV_INCON_CANCEL = '/Movimentacao/Inconsistencia/Cancelar';
  private readonly PATH_MOV_INCON_SANAR = '/Movimentacao/Inconsistencia/Sanar';
  private readonly PATH_MOV_INCON_ALL = '/Movimentacao/Inconsistencia/GetAll';
  private readonly PATH_MOV_INCON_ALT_GESTOR = '/Movimentacao/gestor/AlteracaoCautela';
  private readonly PATH_MOV_EV_JUNTAS = '/Movimentacao/Evidencia/Juntas/';
  private readonly PATH_MOV_EV_AVULSO = '/Movimentacao/Evidencia/CadastrarEvidencia/';
  private readonly PATH_MOV_EV = '/Movimentacao/Evidencia/';
  private readonly PATH_MOV_EV_SANATORIAS = '/Movimentacao/Evidencia/Sanatorias/';

  //CRUD TIPO DE MOVIMENTAÇÃO
  private readonly PATH_TIP_MOV = '/TipoMovimentacao';
  private readonly PATH_TIP_MOV_GET_ALL = '/TipoMovimentacao/GetAll';


  constructor(private http: HttpClient) { }

  public errorHandl(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }
  //MOVIMENTAÇÃO
  insert_liberar(movimentacao: Movimentacao): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_LIBERAR, movimentacao, { responseType: 'text' })
  }

  insert_aprovar(cD_BPM_BEM_PATRIMONIAL: number): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'text/plain', 'No-Auth': 'True' });
    return this.http.post(env.baseurl + this.PATH_APROVAR + '/' + JSON.stringify(cD_BPM_BEM_PATRIMONIAL), { headers: reqHeader, responseType: 'text' })
  }

  insert_reprovar(cD_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_REPROVAR + '/' + cD_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
  }

  insert_receber(cD_BPM_BEM_PATRIMONIAL: number): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_RECEBER + '/' + cD_BPM_BEM_PATRIMONIAL, { responseType: 'text' })
  }

  insert_nao_receber(cD_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_NO_RECEBER + '/' + cD_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
  }

  mov_getAll(): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_MOV);
  }
  mov_getById(cD_BPM_BEM_PATRIMONIAL: number) {
    return this.http.get(env.baseurl + this.PATH_MOV + '/' + cD_BPM_BEM_PATRIMONIAL, { responseType: 'text' })
  }

  mov_getBy2Id(NR_BPM_BEM_PATRIMONIAL: number, CD_BPM_MOVIMENTACAO_PATRIMONIAL: number) {
    return this.http.get(env.baseurl + this.PATH_MOV + '/' + NR_BPM_BEM_PATRIMONIAL + '/' + CD_BPM_MOVIMENTACAO_PATRIMONIAL)
  }

  mov_listarPage(page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_GET_ALL, page)
      .pipe(catchError(this.errorHandl));
  }
  mov_listarHistorico(NR_BPM_BEM_PATRIMONIAL: number, page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_HIST + '/' + NR_BPM_BEM_PATRIMONIAL, page)
      .pipe(catchError(this.errorHandl));
  }

  mov_gestor(cD_CDU_MATRICULA_GESTOR: number): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_GESTOR + '/' + cD_CDU_MATRICULA_GESTOR)
  }

  mov_listarPageGestor(cD_CDU_MATRICULA: number, page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_GESTOR_GET_ALL + '/' + cD_CDU_MATRICULA, page)
      .pipe(catchError(this.errorHandl));
  }

  mov_destino(CD_CDU_MATRICULA_DESTINO: number): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_DESTINO + '/' + CD_CDU_MATRICULA_DESTINO)
  }

  mov_listarPageDestino(cD_CDU_MATRICULA: number, page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_DESTINO_GET_ALL + '/' + cD_CDU_MATRICULA, page)
      .pipe(catchError(this.errorHandl));
  }

  mov_delete(cD_BPM_MOVIMENTACAO_PATRIMONIAL: number, cD_BPM_BEM_PATRIMONIAL: number) {
    return this.http.delete(env.baseurl + this.PATH_MOV + '/' + cD_BPM_MOVIMENTACAO_PATRIMONIAL + '/' + cD_BPM_BEM_PATRIMONIAL, { responseType: 'text' })
  }

  mov_getInconOrigAll(cD_CDU_MATRICULA_ORIGEM: number, page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_INCON_ORIG_ALL + '/' + cD_CDU_MATRICULA_ORIGEM, page)
      .pipe(catchError(this.errorHandl));
  }

  mov_getInconGetAll(page: any, params: any): Observable<any> {
    ////console.log/params)
      return this.http.post(env.baseurl + this.PATH_MOV_INCON_GET_ALL,page,
        {params}) 
        .pipe(catchError(this.errorHandl));

    
  }

  mov_confirmInconOrig(cD_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(
      env.baseurl + this.PATH_MOV_INCON_ORIG_CONF
      + '/' + cD_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
  }
  mov_confirmInGestor(cD_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(
      env.baseurl + this.PATH_MOV_INCON_GESTOR_CONF
      + '/' + cD_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
  }

  mov_cancelIncon(cD_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(
      env.baseurl + this.PATH_MOV_INCON_CANCEL
      + '/' + cD_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
  }

  mov_Incon_All(page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_INCON_ALL, page)
      .pipe(catchError(this.errorHandl));
  }
  mov_Incon_Sanar(nR_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_INCON_SANAR
      + '/' + nR_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' })
      .pipe(catchError(this.errorHandl));
  }
  mov_Incon_Alt_Gestor(movimentacao: Movimentacao): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_INCON_ALT_GESTOR,
      movimentacao, { responseType: 'text' });

  }
  mov_getEv(
    nR_BPM_BEM_PATRIMONIAL: number,
    cD_BPM_MOVIMENTACAO_PATRIMONIAL: number): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_MOV_EV
      + nR_BPM_BEM_PATRIMONIAL + "/" + cD_BPM_MOVIMENTACAO_PATRIMONIAL);
  }
  mov_getJuntasEv(nR_BPM_BEM_PATRIMONIAL: number): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_EV_JUNTAS + nR_BPM_BEM_PATRIMONIAL, { responseType: 'json' });
  }
  mov_getEvAvulso(nR_BPM_BEM_PATRIMONIAL: number, evidencia: Evidencia): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_EV_AVULSO
      + nR_BPM_BEM_PATRIMONIAL, evidencia, { responseType: 'text' });
  }
  mov_getEvSanatoria(nR_BPM_BEM_PATRIMONIAL: number): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_EV_SANATORIAS
      + nR_BPM_BEM_PATRIMONIAL, { responseType: 'text' });
  }
  mov_getHistDetalhar(nR_BPM_BEM_PATRIMONIAL: number, cD_BPM_MOVIMENTACAO_PATRIMONIAL: number, cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM: number): Observable<any> {
    return this.http.get(
      env.baseurl + this.PATH_MOV + "/" +
      nR_BPM_BEM_PATRIMONIAL + "/" + cD_BPM_MOVIMENTACAO_PATRIMONIAL + "/" +
      cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM);
  }
  mov_getRelatorio(nR_BPM_BEM_PATRIMONIAL: number):Observable<any>{
    return this.http.get(env.baseurl + this.PATH_RELATORIO + nR_BPM_BEM_PATRIMONIAL,{responseType: 'blob'}).pipe(catchError(this.errorHandl));
  }
  mov_incon_getRelatorio(relatorio:RelatorioIncon):Observable<any>{
    return this.http.post(env.baseurl + this.PATH_MOV_INCON_RELATORIO,relatorio,{responseType:'blob'})
  }


  //TIPO DE MOVIMENTAÇÃO
  insert_tipo_mov(tipoMovimentacao: TipoMovimentacao) {
    return this.http.post(env.baseurl + this.PATH_TIP_MOV, tipoMovimentacao, { responseType: 'text' })
  }
  tipo_mov_listarPage(page: any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_TIP_MOV_GET_ALL, page)
      .pipe(catchError(this.errorHandl));
  }
  tipo_mov_getAll(): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_TIP_MOV, { responseType: 'text' });
  }
  tipo_mov_getById(cD_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL: number): Observable<any> {
    return this.http.get(env.baseurl + this.PATH_TIP_MOV + '/' + cD_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL, { responseType: 'text' });
  }
  tipo_mov_update(tipoMovimentacao: TipoMovimentacao): Observable<any> {
    return this.http.put(env.baseurl + this.PATH_TIP_MOV, tipoMovimentacao, { responseType: 'text' })
  }
  tipo_mov_delete(cD_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL: number): Observable<any> {
    return this.http.delete(env.baseurl + this.PATH_TIP_MOV + '/' + cD_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL, { responseType: 'text' });
  }
}